import Vue from 'vue';
import VueI18n from 'vue-i18n';
import jaMsg from './ja/ja.json';
import enMsg from './en/en.json';

Vue.use(VueI18n);

const messages = {
  ja: jaMsg,
  en: enMsg,
};

const lang = localStorage.getItem('lang');
const locale = (lang && Object.prototype.hasOwnProperty.call(messages, lang)) ? lang : 'ja';

const i18n = new VueI18n({
  locale,

  messages,
});

export default i18n;
